/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAllTasksForOfflineQueryResponse, ListAllTasksForOfflinePathParams, ListAllTasksForOfflineQueryParams, ListAllTasksForOffline400, ListAllTasksForOffline401, ListAllTasksForOffline403, ListAllTasksForOffline404, ListAllTasksForOffline409, ListAllTasksForOffline500 } from "../../types/planningTasksController/ListAllTasksForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAllTasksForOfflineUrl(organizationId: ListAllTasksForOfflinePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/tasks/all` as const }
  return res
}

/**
 * @summary Full non-paginated task dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/tasks/all}
 */
export async function listAllTasksForOffline(organizationId: ListAllTasksForOfflinePathParams["organizationId"], params?: ListAllTasksForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAllTasksForOfflineQueryResponse, ResponseErrorConfig<ListAllTasksForOffline400 | ListAllTasksForOffline401 | ListAllTasksForOffline403 | ListAllTasksForOffline404 | ListAllTasksForOffline409 | ListAllTasksForOffline500>, unknown>({ method : "GET", url : getListAllTasksForOfflineUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}